import { create } from 'zustand';

export interface Toast {
  id: number;
  kind: 'info' | 'success' | 'error' | 'notification';
  title: string;
  body?: string;
  /** Ziel beim Anklicken (App-Pfad). */
  to?: string;
  iconUrl?: string | null;
}

export interface SuperBurst {
  id: number;
  messageId: string;
  emoji: { id: string | null; name: string; animated: boolean };
}

interface UiState {
  toasts: Toast[];
  pushToast(t: Omit<Toast, 'id'>, ttlMs?: number): number;
  dismissToast(id: number): void;
  /** Laufende Super-Reaktion-Animationen. */
  bursts: SuperBurst[];
  burst(b: Omit<SuperBurst, 'id'>): void;
  /** Mobile Drawer. */
  navOpen: boolean;
  membersOpen: boolean;
  setNavOpen(v: boolean): void;
  setMembersOpen(v: boolean): void;
  /** Mitgliederliste am Desktop eingeblendet. */
  showMembers: boolean;
  toggleMembers(): void;
}

let seq = 1;

export const useUi = create<UiState>((set, get) => ({
  toasts: [],
  pushToast: (t, ttlMs = 6000) => {
    const id = seq++;
    set({ toasts: [...get().toasts.slice(-4), { ...t, id }] });
    if (ttlMs > 0) setTimeout(() => get().dismissToast(id), ttlMs);
    return id;
  },
  dismissToast: (id) => set({ toasts: get().toasts.filter((t) => t.id !== id) }),
  bursts: [],
  burst: (b) => {
    const id = seq++;
    set({ bursts: [...get().bursts, { ...b, id }] });
    setTimeout(() => set({ bursts: get().bursts.filter((x) => x.id !== id) }), 1600);
  },
  navOpen: false,
  membersOpen: false,
  setNavOpen: (navOpen) => set({ navOpen }),
  setMembersOpen: (membersOpen) => set({ membersOpen }),
  showMembers: true,
  toggleMembers: () => set({ showMembers: !get().showMembers }),
}));

export const toast = {
  info: (title: string, body?: string) => useUi.getState().pushToast({ kind: 'info', title, body }),
  success: (title: string, body?: string) => useUi.getState().pushToast({ kind: 'success', title, body }),
  error: (title: string, body?: string) => useUi.getState().pushToast({ kind: 'error', title, body }, 8000),
};
